import { Connect } from '../react';
import { Action } from 'redux';
import React from 'react';
import FocusLock from 'react-focus-lock';
import { hack } from '../browser/launch';
import cx from './styles.less';

@Connect(
    (state: any) => ({
        buttonNo: state.notemenu?state.notemenu.buttonNo:0,
        buttonAction: state.buttonAction?state.notemenu.buttonAction:undefined,
    }),
    (dispatch: any) => ({
        custom(action: Action) { dispatch(action); },
    }),
)
export default class Wrapper extends React.Component<any, any> {
    thisButtonNo = this.props.thisButtonNo;
    thisButtonAction = this.props.thisButtonAction;
    onFocus = this.props.onFocus;
    ref= React.createRef<HTMLElement>();
    
    public componentDidMount() {  
      if ((hack.store.getState().notemenu.buttonNo===this.props.thisButtonNo) &&
        (hack.store.getState().notemenu.buttonAction===this.props.thisButtonAction)) {         
        {
            if (this.props.updateAfterMount) {
                this.forceUpdate();
            }
        } 
      }
    }  

    public componentDidUpdate() {                   
        if (this.props.updatedlock) {           
            
            if ((hack.store.getState().notemenu.buttonNo===this.props.thisButtonNo) &&
                (hack.store.getState().notemenu.buttonAction===this.props.thisButtonAction)) {                      
                // this.ref.current.focus();  
                if (this.ref) { 
                    if (this.props.children) {
                        var reference: any = this.ref; 
                        if (reference.focus) {
                                reference.focus(); 
                        }
                    } else {
                            this.ref.current.focus();
                    }
                }
                (this.props as any).custom(this.props.updatedlock());
            }
        }
    }             
  
    public render() { 
        // const thisButtonNo = this.props.thisButtonNo;
        // const { buttonNo } = this.props as any;
        const onFocus = this.props.onFocus; 
        const childArray= [this.props.children];

        return (
            <FocusLock className={cx('focus-lock-style')} noFocusGuards={true} disabled={!((hack.store.getState().notemenu.buttonNo===this.props.thisButtonNo) &&
                                                        (hack.store.getState().notemenu.buttonAction===this.props.thisButtonAction)) 
            }>
                <div tabIndex={-1} onFocus={onFocus} className={cx('wrapper-style')}>
                    { // this.props.children as JSX.Element
                        ((childArray!==undefined) && (childArray.length===1)?
                            React.cloneElement(
                            React.Children.only(this.props.children), 
                            { ref: (el: any) => this.ref = el })
                        : this.props.children)
                    }
                </div>
            </FocusLock>
        );
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/focuslock/wrapper.tsx